export default function mimeType(str: string | null | undefined) {
  if (!str) return null;
  return str.split(".").at(-1) ?? null;
}
